import { Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { RowControlsRenderer } from "../../shared/components/AgGrid/RowControlsRenderer";
import { getDateFormatter, gridConfig } from "../../shared/constants/AgGrid/GridConfig";
import { getDateColumnConfig } from "../../shared/services/SharedService";
import RequestTypeDetails from "./RequestTypeDetails/RequestTypeDetails";
import './RequestType.css';
import RefreshIcon from '@material-ui/icons/Refresh';

export default function RequestType(props) {
  const [requestTypeList, setRequestTypeList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    getRequestTypeList(true);
  }, []);

  const getRequestTypeList = async (resetPage) => {
    try {
      let data;
      const response = await axios.get(
        `${global.REACT_APP_API_ENDPOINT}/requestType/getRequestTypes`, 
        {}
      );
      data = response.data;
      setRequestTypeList(data);
      props.setGridData(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddClick = () => {
    setSelectedData({});
    setEdit(false);
    setShowModal(true);
  };

  const handleEditClick = (data) => {
    setSelectedData(data);
    setEdit(true);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setSelectedData({});
    setEdit(false);
    setShowModal(false);
  };

  const handleSave = () => {
    handleModalClose();
    getRequestTypeList(false);
  };

  const validationOnSave = (data, errorData) => {
    let isValid = true;
    [{ key: 'requestTypeName', label: 'Name' }].forEach(attr => {
      const duplicates = requestTypeList.filter(ele => ele[attr.key] === data[attr.key]);
      
      if (duplicates.length === 0) {
        isValid = isValid && true;
      } else {
        errorData[`${attr.key}Err`] = `${attr.label} already exist`;
        isValid = false;
      }
    });
    return isValid;
  };

  const gridRef = useRef(null);
  
  const gridOptions = {
    ...gridConfig,

    columnDefs: [
      { headerName: "Name", field: "requestTypeName", sort: "asc", },
      { headerName: "Active", field: "active", cellDataType: "boolean", maxWidth: 100, },
      { headerName: "Created By", field: "createdBy", },
      { headerName: "Updated By", field: "updatedBy", },
      {
        headerName: "Updated At",
        field: "updatedDate",
        ...getDateColumnConfig(),
      },
      { 
        headerName: "", 
        sortable: false,
        filter: false,
        cellRenderer: RowControlsRenderer, 
        cellRendererParams: {
          canEdit: true,
          onEditClick: handleEditClick,
        },
        maxWidth: 90,
      },
    ],
    
    dataTypeDefinitions: {
      ...gridConfig.dataTypeDefinitions,
      date: getDateFormatter("MM/DD/YYYY hh:mm:ss A"),
    },
  };
  
  useEffect(() => {
    props.setGridOptions(gridOptions);
  }, []);

  const onRefreshClick = () => {
    getRequestTypeList(true);
    props.gridRef.current.api.resetColumnState();
    props.gridRef.current.api.paginationGoToPage(0);
  }

  return (
    <>
    {
      props.gridRef?props.gridRef.current?props.gridRef.current.api?
      props.gridRef.current.api.paginationGoToPage(0):null:null:null   
    }
      <div style={{position: "absolute", top: "-50px", right: 0}}>
        <Button
          variant="contained"
          onClick={handleAddClick}
          style={{
            backgroundColor: "rgb(17, 118, 181)",
            textTransform: "none"
          }}
          color="primary"
        >
          <Add />
          Add Request Type
        </Button>
      </div>

      <div style={{position: "absolute", top: "-50px", right: 200}}>
        <Button
          variant="contained"
          onClick={onRefreshClick}
          style={{
            backgroundColor: "rgb(17, 118, 181)",
            textTransform: "none"
          }}
          color="primary"
        >
          Refresh
          <RefreshIcon />
        </Button>
      </div>

      {requestTypeList?.length ? (     
        <></>
      ) : (<p className="error"> No records found. </p>)}

      <RequestTypeDetails
        show={showModal}
        isEdit={isEdit}
        handleClose={handleModalClose}
        handleSave={handleSave}
        data={selectedData}
        handleValidation={validationOnSave}
      />
    </>
  );
}
